import { useNavigate } from 'react-router-dom';

import { TableRow, TableCell } from '@occc/ui-design-system';
import { RetailerNetworkLocationForMember } from '@occc/graphql';
import { routeCreator } from '@occc/feat-retailer-connect';

import { mapRoleTypeToLabel } from '../constants';

type RetailerNetworkLocationsForMemberRowProps = {
  location: RetailerNetworkLocationForMember;
};

export const RetailerNetworkLocationsForMemberRow = ({
  location,
}: RetailerNetworkLocationsForMemberRowProps) => {
  const navigate = useNavigate();
  const onTableRowClick = () =>
    navigate(routeCreator.locationDetails(location.retailerNetworkUuid, location.uuid));

  return (
    <TableRow key={location.uuid} onClick={onTableRowClick}>
      <TableCell>{location.siteId}</TableCell>
      <TableCell>{location.siteName}</TableCell>
      <TableCell>{location.role && mapRoleTypeToLabel[location.role]}</TableCell>
    </TableRow>
  );
};
